const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue');
const Estoque = () => System.import('../App/View/Estoque.vue');
const ConsultaEstoque = () => System.import('../App/View/ConsultaEstoque.vue');

export const EstoqueRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      {path: 'estoque', component: Estoque, name: 'estoque', meta: {auth: true}},
      {path: 'estoque/consultaestoque', component: ConsultaEstoque, name: 'estoque-consulta-estoque', meta: {auth: true}},
      {path: 'estoque/consultaestoque/:id', component: ConsultaEstoque, name: 'estoque-dados-produto-estoque', meta: {auth: true}}
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Estoque/Rotas/Routes.js